import React from 'react'
import classes from './WorldNews.module.scss';

import { getFileName } from '../../../helpers/FileCaching';
import renderHTML from 'react-render-html';

const introductionImages = require.context('../../../images/components/App', true, /.*\.(gif|png|jpe?g|svg)$/i);

function WorldNews(props) {

    return (

        <a target="_blank" rel="noopener noreferrer" href={props.content.airingTimesLink}>
            <div className={classes.worldNews}>
                
                <span>{renderHTML(props.content.worldNewsTitle)}</span>
                <div className={classes.worldNews__logo}
                    style={
                        {
                        backgroundImage: 'url(' + getFileName(introductionImages, props.content.worldNewsLogo) + ')'
                        }										
                    }>
                </div>

            </div>
        </a>

    )

}

export default WorldNews;